import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_REPORTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { ReportFilters } from './types'

type AccountingReportOriginal = {
  number: string
  name: string
  employee_no: string
  accounting_code: string
  department_name: string
  department_code: string
  dim1: string
  dim2: string
  dim3: string
  dim4: string
  from_period: string
  to_period: string
  gross_debit: string
  gross_credit: string
  project: string
  net_amount: number
  vat_amount: number
  total_amount: number
  org_no: string
  company_name: string
  invoice_no: string
  vendor_net_amount: number
  vendor_vat_amount: number
  vendor_gross_amount: number
  net_vat: number
  net_no_vat: number
}
const IS_NEW_BACKEND_API = true

export const getAccountingReports = async ({
  selectedReportType,
  toDate,
  fromDate,
  isGlobal,
  selectedCustomer,
}: ReportFilters) => {
  if (!fromDate || !toDate) throw Error('Missing date range filters!')

  const searchParams = new URLSearchParams()
  searchParams.append('fromDate', fromDate)
  searchParams.append('toDate', toDate)
  searchParams.append('isGlobal', isGlobal.toString())
  searchParams.append('customerId', String(selectedCustomer || ''))

  const reports = await get<AccountingReportOriginal[]>(
    `${API_ROUTE_ADMIN_REPORTS}/${selectedReportType}?${searchParams.toString()}`,
    IS_NEW_BACKEND_API
  )

  return mapKeysToCamelCase(reports)
}
